import { ChallengeSummary } from '@wix/ambassador-challenges-v1-challenge/types';
import { State } from '@wix/ambassador-challenges-v1-participant/types';

export function getParticipantStateFromSummary(summary: ChallengeSummary) {
  return summary?.participation?.state as unknown as State;
}
